module.exports = __webpack_public_path__ + "static/media/pharmacy.d9bf99dc.svg";